"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mui_1 = require("tss-react/mui");
const Button_1 = __importDefault(require("@mui/material/Button"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const AccessTypeModal = ({ open, handleClose }) => {
    const { classes } = useStyles();
    return (<Dialog_1.default open={open} sx={{ '& .MuiPaper-root': { py: 0, px: 2.5 } }}>
      <DialogTitle_1.default className={classes.dialogTitleWrapper}>
        <Typography_1.default variant="h6" className={classes.title}>
          Access Type
        </Typography_1.default>
      </DialogTitle_1.default>
      <IconButton_1.default aria-label="close" onClick={handleClose} className={classes.closeButton}>
        <Close_1.default fontSize="small"/>
      </IconButton_1.default>
      <DialogContent_1.default className={classes.accessTypeModalContents}>
        <Typography_1.default gutterBottom variant="subtitle1">
          Full Access
        </Typography_1.default>
        <Typography_1.default gutterBottom variant="body2">
          The invited person will have complete access to your Quicken file with full View & Edit permissions.
        </Typography_1.default>
        <br />
        <Typography_1.default gutterBottom variant="subtitle1">
          Custom Access
        </Typography_1.default>
        <Typography_1.default gutterBottom variant="body2">
          Choose which entities to share and assign either View-Only or View & Edit permissions.
        </Typography_1.default>
      </DialogContent_1.default>
      <DialogActions_1.default className={classes.dialogAction}>
        <Button_1.default onClick={handleClose} variant="outlined" size="small">
          OK
        </Button_1.default>
      </DialogActions_1.default>
    </Dialog_1.default>);
};
exports.default = AccessTypeModal;
